import { render, staticRenderFns } from "./DelegatedUsers.vue?vue&type=template&id=16520cb4&"
import script from "./DelegatedUsers.vue?vue&type=script&lang=js&"
export * from "./DelegatedUsers.vue?vue&type=script&lang=js&"
import style0 from "./DelegatedUsers.vue?vue&type=style&index=0&id=16520cb4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports